// extracted by mini-css-extract-plugin
export var container = "_4z-0";
export var icon = "_4z-1";
export var text = "_4z-2";